/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_What_We_Do_TitleInputs */



/**
* | output |
* | --- |
* | "Inspections, surveys and audits, wherever the vessel is." |
*
* @param {Home_What_We_Do_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_what_we_do_title = /** @type {((inputs?: Home_What_We_Do_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_What_We_Do_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("检查、检验和审核，船在哪里，我们就在哪里。")
	return /** @type {LocalizedString} */ ("Inspections, surveys and audits, wherever the vessel is.")
});